export default "__VITE_PUBLIC_ASSET__b7c4598f__"